const snackbar = document.querySelector(".snackbar");

export const showSnackbar = (message) => {
  const snackbarMessage = document.querySelector(".snackbar__message");
  snackbarMessage.innerText = message;
  document.body.classList.add("body_snackbar");
};

const snackbarClose = snackbar.querySelector(".snackbar__close");

snackbarClose.addEventListener("click", () => {
  document.body.classList.remove("body_snackbar");
});
